<template>
  <div>
    <div class="withdraw_wrapper" v-show="!showResult">
      <div class="withdraw_all">
        <div class="title">
          可提现余额（元）
        </div>
        <div class="money">
          {{
            accountData.balanceWithdrawabl
              ? parseFloat(accountData.balanceWithdrawabl).toLocaleString()
              : 0
          }}
        </div>

        <div class="withdraw_form">
          <div class="form_title">
            提现金额
          </div>
          <div class="form_num">
            <div class="unit">￥</div>
            <van-field
              v-model.trim="withdraw.balanceCash"
              placeholder="请输入金额"
              :border="false"
              type="number"
            />
            <div class="all" @click="withdrawAll">
              全部提现
            </div>
          </div>

          <div class="form_item" v-if="!accountData.alipayAccount">
            <div class="label">到账账户</div>
            <van-field
              v-model.trim="withdraw.alipayAccount"
              placeholder="请输入支付宝账号"
              :border="false"
            />
          </div>
          <div class="form_item" v-if="!accountData.alipayName">
            <div class="label">真实姓名</div>
            <van-field
              v-model.trim="withdraw.alipayName"
              placeholder="请输入支付宝真实姓名"
              :border="false"
            />
          </div>
          <div class="form_item" v-if="accountData.alipayAccount">
            <div class="label">到账账户</div>
            <div class="has_account">
              <div class="account">
                支付宝{{
                  accountData.alipayAccount.substring(0, 3) +
                    '****' +
                    accountData.alipayAccount.substring(7)
                }}
              </div>
              <div class="update" @click="openPage('/alipayAccount')">修改</div>
            </div>
          </div>
          <van-button
            round
            type="info"
            size="normal"
            color="#F93244"
            class="update_btn"
            @click="handleWithdraw"
            >立即提现</van-button
          >
        </div>
      </div>
    </div>
    <div class="pay_result_container" v-show="showResult">
      <div v-show="pathResultType == 'success'">
        <van-icon name="checked" class="success_icon" />
        <div class="result_text">
          提现成功
        </div>
        <div class="pay_money">{{ payMsg }}</div>
      </div>
      <div v-show="pathResultType == 'fail'">
        <van-icon name="warning" class="fail_icon" />

        <div class="result_text">
          提现失败
        </div>
        <div class="pay_money">{{ payMsg }}</div>
      </div>
      <van-button
        round
        type="info"
        size="normal"
        color="#F93244"
        class="btn"
        @click="openPage('/')"
        >返回首页</van-button
      >
    </div>
  </div>
</template>

<script>
import { accountGet, accountUpdate, accountWithdraw } from '@/api';
export default {
  data() {
    return {
      num: '',
      withdraw: {
        balanceCash: '',
        alipayAccount: '',
        alipayName: ''
      },
      accountData: {},
      showResult: false,
      pathResultType: '',
      payMsg: ''
    };
  },
  mounted() {
    accountGet().then((res) => {
      this.accountData = res.data;
    });
  },
  methods: {
    openPage(path) {
      this.$router.push(path);
    },
    handleWithdraw() {
      const { withdraw, accountData } = this;
      //最小两位
      if (withdraw.balanceCash < 10) {
        return this.$toast.fail('提现金额至少10元');
      }

      //小数两位
      if (withdraw.balanceCash.indexOf('.') > -1) {
        if (withdraw.balanceCash.split('.')[1].length > 2) {
          return this.$toast.fail('支持两位小数');
        }
      }

      if (withdraw.balanceCash > accountData.balanceWithdrawabl) {
        return this.$toast.fail('可提现金额不足');
      }

      // 没有支付宝
      if (!this.accountData.alipayAccount || !this.accountData.alipayName) {
        if (
          !/^(?:1[3-9]\d{9}|[a-zA-Z\d._-]*\@[a-zA-Z\d.-]{1,10}\.[a-zA-Z\d]{1,20})$/.test(
            withdraw.alipayAccount
          )
        ) {
          return this.$toast.fail('请输入正确的支付宝账号');
        }

        const data = {
          alipayAccount: withdraw.alipayAccount.trim(),
          alipayName: withdraw.alipayName.trim()
        };

        accountUpdate(data).then((res) => {
          if (res.success) {
            let data = JSON.parse(JSON.stringify(this.accountData));
            data.balanceCash = +withdraw.balanceCash;
            data.alipayAccount = withdraw.alipayAccount;
            data.alipayName = withdraw.alipayName;
            //提现
            this.handleAccountWithdraw(data);
          } else {
            this.$toast.fail(res.msg);
          }
          return;
        });
      } else {
        accountData.balanceCash = +withdraw.balanceCash;
        this.handleAccountWithdraw(accountData);
      }
    },
    handleAccountWithdraw(data) {
      accountWithdraw(data).then((res) => {
        if (res.success) {
          this.pathResultType = 'success';
          this.payMsg = '提现金额：￥' + data.balanceCash;
          this.showResult = true;
        } else {
          this.pathResultType = 'fail';
          this.payMsg = res.msg;
          this.showResult = true;
        }
      });
    },

    // 全部提现
    withdrawAll() {
      this.withdraw.balanceCash = this.accountData.balanceWithdrawabl;
    }
  }
};
</script>

<style lang="less" scoped>
.withdraw_wrapper {
  background-color: #f7f8fa;
  min-height: 100vh;
  .withdraw_all {
    height: 68.4vw;
    background: linear-gradient(138deg, #fd7343 0%, #f93244 100%);
    padding-top: 7.6vw;
    padding-left: 5.333vw;
    position: relative;

    .title {
      font-size: 4.533vw;
      color: #fff;
      margin-bottom: 3.2vw;
    }
    .money {
      font-size: 12vw;
      color: #fff;
    }
  }
  .withdraw_form {
    border-radius: 2.133vw;
    background-color: #fff;
    position: absolute;
    left: 3.2vw;
    right: 3.2vw;
    top: 38.267vw;
    padding: 5.333vw 5.333vw 9.867vw;
    &::after {
      width: 93.6vw;
      content: '如有疑问请联系在线客服~';
      display: inline-block;
      overflow: hidden;
      position: absolute;
      bottom: -7.267vw;
      left: 0;
      text-align: center;
      font-size: 3.733vw;
      color: rgba(0, 0, 0, 0.45);
    }
    .form_title {
      font-size: 3.733vw;
      color: rgba(0, 0, 0, 0.85);
    }

    .form_num {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      margin-top: 7.467vw;
      padding-bottom: 3.2vw;
      .unit {
        font-size: 10.667vw;
        color: rgba(0, 0, 0, 0.85);
        margin-right: 2.133vw;
      }

      .all {
        color: #f93244;
        font-size: 4.533vw;
      }
    }

    .form_item {
      .label {
        margin-top: 5.333vw;
        margin-bottom: 4.267vw;
        font-size: 3.733vw;
        color: rgba(0, 0, 0, 0.85);
      }
      .has_account {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 3.733vw;
        .account {
          color: rgba(0, 0, 0, 0.45);
        }
        .update {
          color: #f93244;
        }
      }
    }
    .update_btn {
      margin-top: 17.333vw;
      width: 82.933vw;
      height: 11.333vw;
    }
  }
}

.pay_result_container {
  padding: 17.067vw 4.267vw;
  text-align: center;
  .success_icon {
    font-size: 17.067vw;
    color: #f93244;
    margin-bottom: 8.533vw;
  }
  .fail_icon {
    font-size: 17.067vw;
    color: #bfbfbf;
    margin-bottom: 8.533vw;
  }
  .result_text {
    font-size: 5.333vw;

    color: #323233;
    margin-bottom: 4.267vw;
  }
  .pay_money {
    font-size: 3.733vw;
    color: rgba(0, 0, 0, 0.65);
    margin-bottom: 30vw;
  }
  .btn {
    width: 91.467vw;
    height: 11.733vw;
    margin-bottom: 5.333vw;
  }
}

/deep/ .van-cell {
  flex: 1;
  padding: 0;
}
</style>
